import { ChangeEvent, FC } from "react";
import { Select } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapperSimple } from "./InputWrapperSimple";

interface Option {
  value: string;
  label: string;
}

interface Props {
  id: string;
  isDisabled?: boolean;
  label?: string;
  fontSize?: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  options: Option[];
}

export const SelectInput: FC<Props> = ({
  id,
  label,
  placeholder,
  options,
  ...props
}) => {
  const [field, meta] = useField(id);
  const type = "select";
  const inputId = `${type}-input-${id}`;

  return (
    <InputWrapperSimple label={label} meta={meta} id={id} type={type}>
      <Select
        {...field}
        id={inputId}
        isInvalid={meta.touched && !!meta.error}
        placeholder={placeholder}
        borderColor={meta.touched && meta.error ? "th.danger1" : "th.cream3"}
        borderWidth={meta.touched && meta.error ? "2px" : "1px"}
        borderRadius="lg"
        fontFamily="Moderat"
        fontWeight="light"
        fontSize="1.125rem"
        lineHeight="140%"
        letterSpacing="0"
        height="3rem"
        _placeholder={{
          color: "th.gray4",
        }}
        _focus={{
          borderColor: meta.touched && meta.error ? "th.danger1" : "th.actionLavender2",
          boxShadow: meta.touched && meta.error
            ? "initial"
            : "0px 1px 2px 0px var(--chakra-colors-newLavender-100)",
        }}
        sx={{
          option: {
            fontFamily: "Moderat",
            fontWeight: "light",
            fontSize: "1.125rem",
          }
        }}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </InputWrapperSimple>
  );
};